import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ExpandableList from 'components/application/ExpandableList';
import InfoBanner from 'components/application/InfoBanner';

import { resourceShape } from 'components/helpers/serialisableResources';

export default function MultiCategoriesSingleDivisionEditable({
  categories,
  riskAssessment,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix:
      'riskRegister.sharedResourceNotices.components.MultiCategoriesSingleDivisionEditable',
  });

  const { t: i18nTRiskRegister } = useTranslation('common', {
    keyPrefix: 'riskRegister',
  });

  return (
    <InfoBanner title={i18nT('title')}>
      {i18nTRiskRegister('riskAssessmentSharedWith', {
        interpolation: { escapeValue: false },
        riskAssessmentName: riskAssessment.attributes.name,
      })}
      <ExpandableList
        collection={categories}
        renderItem={(category) => (
          <li key={category.id}>{category.attributes.name}</li>
        )}
      />
    </InfoBanner>
  );
}

MultiCategoriesSingleDivisionEditable.propTypes = {
  categories: PropTypes.arrayOf(resourceShape('trade')).isRequired,
  riskAssessment: resourceShape('masterActivity').isRequired,
};
